import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { findSiteMap, siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';

const isLeafNode = item => item && item.children.length === 0 && item.selected === true;

export const CalloutWithSiteMap = ({
  siteMap,
  calloutEntity,
  onNext,
  onSkip,
}) => {
  const [inBlackListFlag, setInBlackList] = useState(-1);
  const [initialized, setInitialized] = useState(false);

  const selectedParent = useMemo(() => _.findWhere(siteMap, { selected: true }), [siteMap]);
  const selectedChild = useMemo(() =>
    selectedParent && findSiteMap([selectedParent], isLeafNode), [selectedParent]);

  useEffect(() => {
    if (!initialized) {
      if ((selectedParent && selectedParent.id === calloutEntity.sitemapId) ||
        (selectedChild && selectedChild.id === calloutEntity.sitemapId)) {
        onSkip();
        setInBlackList(1);
      } else {
        setInBlackList(0);
      }
      setInitialized(true);
    }
  }, [calloutEntity, initialized, onSkip, selectedChild, selectedParent]);

  return (
    inBlackListFlag === 0 && calloutEntity && calloutEntity.component ?
      <calloutEntity.component {...calloutEntity.props} onNext={onNext} /> : null
  );
};

CalloutWithSiteMap.propTypes = {
  siteMap: siteMapPropType.isRequired,
  calloutEntity: PropTypes.shape({}).isRequired,
  onNext: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
};
